import React from 'react'
import PropTypes from 'prop-types'
import {Box, SimpleGrid, Stack, Image, useMultiStyleConfig} from '@chakra-ui/react'
import CustomLink from '../../custom-link'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const QuickLinksBraun = ({quickLinksSchema}) => {
    const styles = useMultiStyleConfig('Footer', {variant: 'braun'})
    const {buildUrl} = useMultiSite()

    const columnsDesktop =
        (quickLinksSchema.length === 1 && '1fr') ||
        (quickLinksSchema.length === 2 && '1fr 1fr') ||
        (quickLinksSchema.length === 3 && '1fr 1fr 1fr') ||
        '1fr 1fr 1fr 1fr'

    const columnsMobile =
        (quickLinksSchema.length === 1 && '1fr') || (quickLinksSchema.length >= 2 && '1fr 1fr')

    return (
        <SimpleGrid
            {...styles.simpleGrid}
            gridTemplateColumns={{base: columnsMobile, lg: columnsDesktop}}
        >
            {quickLinksSchema.map((item, index) => {
                const isExternalUrl = !!item?.is_external_url

                return (
                    <Stack {...styles.benefitStack} key={index}>
                        <Image
                            src={item?.icon?.url}
                            alt={item?.icon?.description}
                            {...styles.benefitIcons}
                        />
                        <Box>
                            <CustomLink
                                isExternal={isExternalUrl}
                                href={isExternalUrl ? item?.cta?.href : buildUrl(item?.cta?.href)}
                                {...styles.benefitText}
                            >
                                {item?.cta?.title}
                            </CustomLink>
                        </Box>
                    </Stack>
                )
            })}
        </SimpleGrid>
    )
}

QuickLinksBraun.propTypes = {
    quickLinksSchema: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.shape({url: PropTypes.string, title: PropTypes.string}),
            cta: PropTypes.shape({href: PropTypes.string, title: PropTypes.string}),
            is_external_url: PropTypes.bool,
        }),
    ).isRequired,
}

export default QuickLinksBraun
